import { QuoteCancelationPatchRequestBody, QuoteCancelationPatchRequestParams } from '@lio/api-types';
import { quoteFormQueryKeys } from '@services/quoteForm';
import { quoteItemQueryKey } from '@services/quoteItem';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useReactivateCanceledQuote = () => {
  const queryClient = useQueryClient();
  const client = useClient();
  const mutationFn = (request: QuoteCancelationPatchRequestBody & QuoteCancelationPatchRequestParams) => {
    const { quoteId, quoteCancelationId, reinstatedByUserId, quoteEffective } = request;
    const url = `quote/${quoteId}/cancelation/${quoteCancelationId}`;
    return client.patch(url, {
      json: { reinstatedByUserId, quoteEffective },
    });
  };
  const result = useMutation({
    mutationFn,
    onSuccess: async (data, request) => {
      await queryClient.invalidateQueries({
        queryKey: ['quote', { quoteId: request.quoteId }],
      });
      await queryClient.invalidateQueries({
        queryKey: quoteItemQueryKey.searchWithParams({ quoteId: request.quoteId }),
      });
      await queryClient.invalidateQueries({
        queryKey: quoteFormQueryKeys.get(request.quoteId),
      });
    },
  });
  return { ...result, reactivateQuote: result.mutate };
};
